<template>

    <div class="container" v-show="showScanMailboxesEnding">

        <div class="banner">

            <p class="text-baseRegular-2 color__white">{{ message }}</p>

            <button class="text-lSemibold color__white" @click="close">{{ $t('global_cta_understood') }}</button>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

export default {

    name: 'multi-scan-completed',

    computed: {
        ...Vuex.mapGetters([
            'showScanMailboxesEnding',
            'newslettersWaitingUserRefresh'
        ]),

        lastMailbox() {
            return this.newslettersWaitingUserRefresh.mailboxes
                ? this.newslettersWaitingUserRefresh.mailboxes[this.newslettersWaitingUserRefresh.mailboxes.length - 1]
                : {}

        },

        message() {
            return this.lastMailbox.count > 0
                ? this.$tc('cleaning_scan_done', 1, {email: this.lastMailbox.email})
                : this.$tc('cleaning_scan_done_empty', 1, {email: this.lastMailbox.email})
        }
    },

    methods: {
        ...Vuex.mapActions(['userAcceptNewSubscriptions']),
        close() {
            this.userAcceptNewSubscriptions()
        }
    }

}
</script>

<style lang="scss" scoped>

.container {
    width: 100%;
    padding: 8px 16px;

    .banner {
        z-index: 1;
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        text-align: left;
        background-color: $midnight;
        border-radius: 12px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05), 0 10px 15px 0 rgba(0, 0, 0, 0.1);

        > button {
            margin-left: 16px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 8px 16px;
            border-radius: 32px;
            background-color: $aquamarine;
        }
    }
}

</style>
